<template>
  <div class="flex flex-col gap-xl">
    <h3 class="text-center">
      Dette kjennetegner Juridika
    </h3>
    <ul class="flex flex-col gap-l">
      <NettbutikkJuridikaCtaCard
        title="Faglig tyngde"
        description="Våre forfattere er blant de beste og mest anerkjente innenfor sine fagområder. Juridikas lovkommentarer er ansett for å være de lovkommentarer som dypest og bredest behandler fagstoffet."
        :shape="{ variant: 'decagon', color: 'grey' }"
      />
      <NettbutikkJuridikaCtaCard
        title="Oppdatert"
        description="Juridikas fagstoff holdes kontinuerlig oppdatert slik at de til enhver tid er egnet til å speile rettsutviklingen."
        :shape="{ variant: 'hexagonTilted', color: 'peach' }"
      />
      <NettbutikkJuridikaCtaCard
        title="Brukervennlighet i sentrum"
        description="Juridika er opptatt av å ha en tjeneste som gjør brukernes arbeidsflyt så effektiv som mulig. Det arbeides løpende med å utvikle ny funksjonalitet i tråd med brukernes behov."
        :shape="{ variant: 'star', color: 'green' }"
      />
    </ul>
  </div>
</template>
